import { Component } from '@angular/core';
import { ScreenService } from '@core/framework/screen.service';
import {BaseComponent} from "@base/component/BaseComponent";
import {BaseState} from "@base/entities/BaseEntities";
import {ServiceBagService} from "@base/component/ServiceBag";
import {DemoPage} from "@ui/demo/models/demo-page";

class State extends BaseState {
    Pages: DemoPage[] = [];
}

@Component({
    selector: 'm4u-demo-navbar',
    templateUrl: './demo-navbar.component.html',
    styleUrls: ['./demo-navbar.component.scss']
})
export class DemoNavbarComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService, public screen: ScreenService) {
        super(A, 'DemoNavbarComponent', State);
    }

    override OnInitComponent() {
        this.State.Pages = this.GetPages();
    }
    
    public onPageSelected(url: string) {
        this.Navigate([url]);
    }
    
    private GetPages(): DemoPage[] {
        return [
            { Text: "Buttons", Url: "/demo/buttons" },
            { Text: "Editors", Url: "/demo/editors" },
            { Text: "Layouts", Url: "/demo/layouts" },
            { Text: "Components", Url: "/demo/components" }, // Add upload component and spinner-loader 
            { Text: "Sections", Url: "/demo/sections" },
            { Text: "Cards", Url: "/demo/cards" },
            { Text: "Tabs", Url: "/demo/tabs" },
            { Text: "Grids", Url: "/demo/grids" },
            { Text: "Pages", Url: "/demo/page-examples" },
            { Text: "Sidebars", Url: "/demo/sidebars" },
            { Text: "Bottom Sheets", Url: "/demo/bottom-sheets" },
            { Text: "Dialogs", Url: "/demo/dialogs" },
            { Text: "Pipes", Url: "/demo/pipes" }
        ]
    }
}